import { PostageType } from "@bbj-types/maileva/enum";
import type { TDocumentMetadataTypes } from ".";
import { DocumentTypes } from "./enum";

export const documentTypesLabels = {
  [DocumentTypes.TEMPORARY]: "Temporaire",
  [DocumentTypes.OTHER]: "Autre",
  [DocumentTypes.CER]: "CE",
  [DocumentTypes.CER_TEMPLATE]: "Modèle de CE",
  [DocumentTypes.CGU]: "CGU",
  [DocumentTypes.CHARTER_COMMITMENT]: "Charte d'engagement",
  [DocumentTypes.PARTNERSHIP_CONTRACT]: "Contrat de partenariat",
  [DocumentTypes.CONVOCATION]: "Convocation",
  [DocumentTypes.RESUME]: "CV",
  [DocumentTypes.EPT]: "Réorientations et maintiens",
  [DocumentTypes.EPT_RENEWAL_TEMPLATE]: "Modèle de demande de Renouvellement EPT",
  [DocumentTypes.EPT_REORIENTATION_TEMPLATE]: "Modèle de demande de Réorientation EPT",
  [DocumentTypes.ATTENDANCE_SHEET]: "Feuille d'émargement",
  [DocumentTypes.POSITIONING_SHEET]: "Fiche de positionnement",
  [DocumentTypes.COVER_LETTER]: "Lettre de motivation",
  [DocumentTypes.WORKSHOP_MAIL]: "Courrier d'atelier",
  [DocumentTypes.WORKSHOP_MAIL_TEMPLATE]: "Modèle de courrier d'atelier",
  [DocumentTypes.SOCIAL_OFFER]: "Offre sociale",
  [DocumentTypes.TRAINING_OFFER]: "Offre de formation",
  [DocumentTypes.EMPLOYMENT_CONTRACT]: "Contrat de travail",
  [DocumentTypes.ATTACHMENT]: "Pièce jointe",
  [DocumentTypes.RSA_JUSTIFICATION]: "Justificatif RSA",
  [DocumentTypes.FT_REGISTRATION_PROOF]: "Preuve d'inscription FT",
  [DocumentTypes.ACCOMPANYING_ASSESSMENT]: "Bilan d'accompagnement",
  [DocumentTypes.ADMINISTRATIVE_DOCUMENT]: "Document administratif",
  [DocumentTypes.FUP_TEMPLATE]: "Modèle fiche de prescription",
  [DocumentTypes.FUP]: "Fiche de prescription",
  [DocumentTypes.ABSENCE_JUSTIFICATION]: "Justificatif d'absence",
  [DocumentTypes.COACHING_SUMMARY]: "Résumé d’accompagnement",
  [DocumentTypes.CANDIDATE_MAIL_TEMPLATE]: "Modèle de courrier candidat",
  [DocumentTypes.SANCTION]: "Sanction",
  [DocumentTypes.FINANCIAL_AID]: "Aides financières",
} as const satisfies Record<DocumentTypes, string>;

export const documentDefaultMetadata: TDocumentMetadataTypes = {
  [DocumentTypes.WORKSHOP_MAIL_TEMPLATE]: {
    colorPrinting: false,
    duplexPrinting: true,
    postageType: PostageType.ECONOMIC,
  },
  [DocumentTypes.CANDIDATE_MAIL_TEMPLATE]: {
    colorPrinting: false,
    duplexPrinting: true,
    postageType: PostageType.ECONOMIC,
  },
};

const isKeyOfTDocumentMetadataTypes = (typeDoc: DocumentTypes): typeDoc is keyof TDocumentMetadataTypes =>
  Object.keys(documentDefaultMetadata).includes(typeDoc);

export const getDefaultDocumentMetadata = <T extends DocumentTypes>(
  typeDoc: T
): T extends keyof TDocumentMetadataTypes ? TDocumentMetadataTypes[T] : undefined => {
  if (isKeyOfTDocumentMetadataTypes(typeDoc)) {
    // biome-ignore lint/suspicious/noExplicitAny: <explanation>
    return documentDefaultMetadata[typeDoc] as any;
  }
  // biome-ignore lint/suspicious/noExplicitAny: <explanation>
  return undefined as any;
};
